import React from 'react';

const Modal = (props) => (
  <div className="obs-modal">
    <div className={` modal-dimScreen ${props.status}`}></div>
    <div className="container">
      <div className={`modal-container ${props.status}`}>
        {props.children}
      </div>
    </div>
  </div>
)

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Common/Modal.js